import { Heading, RecallAnalyticsIcon } from '@weave/design-system';
import { InfoCard } from '../InfoCard/InfoCard';
import { childStyles } from './styles';

type InsurancePayerMixPotentialCoverageProps = {
  potentialWebCoveragePercentage: number;
};

export const InsurancePayerMixPotentialCoverage = ({
  potentialWebCoveragePercentage,
}: InsurancePayerMixPotentialCoverageProps) => {
  return (
    <InfoCard title="Potential Web Coverage">
      <div css={childStyles}>
        <RecallAnalyticsIcon size={30} />
        <Heading level={2} css={{ margin: 0 }}>
          {potentialWebCoveragePercentage ? `${potentialWebCoveragePercentage}%` : '-'}
        </Heading>
      </div>
    </InfoCard>
  );
};
